import { Grid } from "@mui/material";
import React from "react";
import { images } from "../../../../../constants";
import QTDetailsImageWithLabelSection from "../../../../../common/QTDetailsImageWithLabelSection";
import QTDetailsTextFieldWithLabelSection from "../../../../../common/QTDetailsTextFieldWithLabelSection";
import QTPhoneFieldWithLabelSection from "../../../../../common/QTPhoneFieldWithLabelSection";
import QTDetailsLocationWithLabelSection from "../../../../../common/QTDetailsLocationWithLabelSection";
import QTDetailsLatLongSection from "../../../../../common/QTDetailsLatLongSection";

const GAAddDataFieldsSection = ({
  handleImagePreviewModalOpen,
  uploadImage,
  setUploadImage,
  uploadImageOP,
  setUploadImageOP,
  addOrganizationField,
  setAddOrganizationField,
  editEnabled,
  setEditEnabled,
}) => {
  //   console.log("222", orgDetail);
  return (
    <Grid container style={dataContainerStyles}>
      {/*left side column*/}
      <Grid item container direction={"column"} xs>
        {/*photo section*/}
        <QTDetailsImageWithLabelSection
          label={"Org Tile Photo"}
          // image={addAlbumsField?.images?.photoUrl}
          image={images.tableDummyImage}
          handleImagePreviewModalOpen={handleImagePreviewModalOpen}
          editEnabled={editEnabled}
          details={addOrganizationField}
          setDetails={setAddOrganizationField}
          uploadImage={uploadImage}
          setUploadImage={setUploadImage}
          setEditEnabled={setEditEnabled}
        />
        <QTDetailsImageWithLabelSection
          label={"Org Logo"}
          image={images.tableDummyImage}
          handleImagePreviewModalOpen={handleImagePreviewModalOpen}
          editEnabled={editEnabled}
          details={addOrganizationField}
          setDetails={setAddOrganizationField}
          uploadImage={uploadImageOP}
          setUploadImage={setUploadImageOP}
          setEditEnabled={setEditEnabled}
        />
        {/*Org Title section*/}
        <QTDetailsTextFieldWithLabelSection
          label={"Org Name"}
          value={addOrganizationField?.name}
          disabled={true}
          editEnabled={editEnabled}
          onChange={(e) =>
            setAddOrganizationField({
              ...addOrganizationField,
              name: e.target.value,
            })
          }
        />
        {/*Org username section*/}
        <QTDetailsTextFieldWithLabelSection
          // label={"Org Username"}
          label={"Org Handle"}
          value={addOrganizationField.handle}
          disabled={true}
          editEnabled={editEnabled}
          onChange={(e) => {
            const value = e.target.value;
            setAddOrganizationField({
              ...addOrganizationField,
              handle: value,
            });

            // setAddOrganizationField({
            //   ...addOrganizationField,
            //   handle: e.target.value,
            // });
          }}
        />
        {/*location section*/}
        <QTDetailsLocationWithLabelSection
          label={"Location"}
          locationDisplayValue={addOrganizationField?.locationDisplay}
          value={addOrganizationField?.location || ""}
          quicktaleDetails={addOrganizationField}
          disabled={true}
          editEnabled={editEnabled}
          onChange={(docData) => {
            console.log("doc data::", docData);
            setAddOrganizationField({
              ...addOrganizationField,
              coordinates: docData.coordinates,
              location: docData.location,
              locationDisplay: docData.locationDisplay,
              locationCountry: docData.locationCountry,
              g: docData.g,
            });
          }}
        />

        {/*Geo Hash section*/}
        <QTDetailsTextFieldWithLabelSection
          label={"Geohash"}
          value={addOrganizationField?.g?.geohash ?? ""}
          disabled={true}
        />
        {/*Lat/long section*/}

        <QTDetailsLatLongSection
          label={"Lat/Long"}
          // addOrganizationField={addOrganizationField}
          value={
            addOrganizationField?.coordinates?._lat ??
            "" + "," + addOrganizationField?.coordinates?._long ??
            ""
          }
          latValue={addOrganizationField?.coordinates?._lat ?? ""}
          longValue={addOrganizationField?.coordinates?._long ?? ""}
          onChange={(data) => {
            setAddOrganizationField({
              ...addOrganizationField,
              coordinates: data.coordinates,
              location: data.location,
              g: data.g,
            });
          }}
          disabled={true}
          editEnabled={editEnabled}
        />
      </Grid>
      {/*right side column*/}
      <Grid item container direction={"column"} xs>
        {/*Org Contact Name section*/}
        <QTDetailsTextFieldWithLabelSection
          label={"Org Contact Name"}
          value={addOrganizationField.orgContact}
          disabled={true}
          editEnabled={editEnabled}
          onChange={(e) =>
            setAddOrganizationField({
              ...addOrganizationField,
              orgContact: e.target.value,
            })
          }
        />
        {/*Org Email section*/}
        <QTDetailsTextFieldWithLabelSection
          label={"Org E-mail"}
          value={addOrganizationField.email}
          disabled={true}
          editEnabled={editEnabled}
          onChange={(e) =>
            setAddOrganizationField({
              ...addOrganizationField,
              email: e.target.value,
            })
          }
        />

        {/*Org Phone section*/}
        <QTPhoneFieldWithLabelSection
          label={"Org Phone"}
          value={addOrganizationField.phone}
          disabled={true}
          editEnabled={editEnabled}
          onChange={(e) =>
            setAddOrganizationField({
              ...addOrganizationField,
              phone: e.target.value,
            })
          }
        />
        {/* <QTDetailsTextFieldWithLabelSection
          label={"Org Phone"}
          value={addOrganizationField.phone}
          disabled={true}
          editEnabled={editEnabled}
          onChange={(e) =>
            setAddOrganizationField({
              ...addOrganizationField,
              phone: e.target.value,
            })
          }
        /> */}

        {/*Org Phone section*/}

        {/* <QTDetailsTextFieldWithLabelSection
          label={"Org Phone"}
          value={addOrganizationField.phone}
          disabled={true}
          editEnabled={editEnabled}
        /> */}

        {/*Org Status section*/}
        <QTDetailsTextFieldWithLabelSection
          label={"Org Status"}
          value={addOrganizationField.status}
          disabled={true}
          editEnabled={editEnabled}
          select={true}
          dropdownValues={["Active", "Inactive", "Unlisted"]}
          onChange={(e) =>
            setAddOrganizationField({
              ...addOrganizationField,
              status: e.target.value,
            })
          }
        />
      </Grid>
    </Grid>
  );
};

export default GAAddDataFieldsSection;

const dataContainerStyles = {
  borderRadius: 12,
  boxShadow: " 0px 0px 30px 0px rgba(80, 85, 136, 0.15)",
  background: "var(--gray-99, #FCFCFC)",
  padding: "36px 15px",
  marginBottom: 30,
};
